import { useCallback, useEffect, useState } from 'react';

import { getRouteRunId } from './components/workflowShared';
import LandingPage from './pages/LandingPage';
import RunPage from './run/RunPage';

function App() {
  const [currentPath, setCurrentPath] = useState(() => window.location.pathname);
  const routeRunId = getRouteRunId(currentPath);

  const syncCurrentPath = useCallback(() => {
    setCurrentPath(window.location.pathname);
  }, []);

  useEffect(() => {
    window.addEventListener('popstate', syncCurrentPath);

    return () => window.removeEventListener('popstate', syncCurrentPath);
  }, [syncCurrentPath]);

  useEffect(() => {
    if (routeRunId || currentPath === '/') {
      return;
    }

    window.history.replaceState({}, document.title, '/');
    syncCurrentPath();
  }, [currentPath, routeRunId, syncCurrentPath]);

  if (routeRunId) {
    return <RunPage runId={routeRunId} />;
  }

  return (
    <div className="app-shell landing-shell">
      <LandingPage onNavigate={syncCurrentPath} />
    </div>
  );
}

export default App;
